import React,{ useState,useEffect } from 'react';
import MaterialTable from 'material-table';
import { useSelector} from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { useTranslation } from "react-i18next";
import {colors} from '../components/Theme/WebTheme';

import { modernTableStyle, modernTableOptions } from '../common/tableTheme';

export default function Earningreports() {
  const { t,i18n } = useTranslation();
  const isRTL = i18n.dir();
  
  const settings = useSelector(state => state.settingsdata.settings);

    const columns =  [
        { title: t('year') || 'Ano', field: 'year', cellStyle: { fontWeight: 600 } },
        { title: t('months') || 'Mês', field: 'monthsName' },
        { title: t('booking_count') || 'Total de Rotas', field: 'total_rides', cellStyle: { fontWeight: 700, color: '#2563eb' } },
        { title: t('Gross_trip_cost') || 'Custo Operacional Total',  render: rowData => (parseFloat(rowData.tripCost) + parseFloat(rowData.cancellationFee)).toFixed(settings.decimal) , editable:'never', cellStyle: { fontWeight: 600 } },
        { title: t('trip_cost_driver_share') || 'Repasse de Condutores', field: 'rideCost' },
        { title: t('cancellationFee') || 'Cancelamentos', field: 'cancellationFee' },
        { title: t('convenience_fee') || 'Taxa de Operação', field: 'convenienceFee' },
        { title: t('Profit') || 'Margem Operacional',  render: rowData => (parseFloat(rowData.convenienceFee) + parseFloat(rowData.cancellationFee) - parseFloat(rowData.discountAmount)).toFixed(settings.decimal) , editable:'never', cellStyle: { fontWeight: 700, color: '#16a34a' } },
    ];

  const [data, setData] = useState([]);
  const earningreportsdata = useSelector(state => state.earningreportsdata);

  useEffect(()=>{
        if(earningreportsdata.Earningreportss){
            setData(earningreportsdata.Earningreportss);
        }
  },[earningreportsdata.Earningreportss]);

  const [selectedRow, setSelectedRow] = useState(null);

  return (
    earningreportsdata.loading? <CircularLoading/>:
    <MaterialTable
      title=""
      columns={columns}
      style={modernTableStyle}
      data={data}
      onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
      options={modernTableOptions(selectedRow, {
        searchPlaceholder: "Buscar por período...",
        maxBodyHeight: "calc(100vh - 280px)"
      })}
      localization={{
        toolbar: {
          searchPlaceholder: (t('search')),
          exportTitle: (t('export')),
        },
        pagination: {
          labelDisplayedRows: ('{from}-{to} '+ (t('of'))+ ' {count}'),
          firstTooltip: (t('first_page_tooltip')),
          previousTooltip: (t('previous_page_tooltip')),
          nextTooltip: (t('next_page_tooltip')),
          lastTooltip: (t('last_page_tooltip'))
        },
      }}
      
    />
  );
}
